var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiLink',{staticClass:"wrapper",attrs:{"name":"index"}},[_c('UiBaseIcon',{attrs:{"width":"40px","height":"40px","icon-name":"cardprLogo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }